<template>
  <div class="login-container">
    <div class="login-card">
      <h1 class="login-title">Code Mini 管理后台</h1>
      <p class="login-desc">博客管理系统</p>
      <div class="form-group">
        <label>用户名</label>
        <input
          v-model="form.username"
          type="text"
          placeholder="请输入用户名"
          @keyup.enter="handleLogin"
        />
      </div>
      <div class="form-group">
        <label>密码</label>
        <input
          v-model="form.password"
          type="password"
          placeholder="请输入密码"
          @keyup.enter="handleLogin"
        />
      </div>
      <div v-if="errorMsg" class="error-msg">{{ errorMsg }}</div>
      <button class="login-btn" :disabled="loading" @click="handleLogin">
        {{ loading ? '登录中...' : '登 录' }}
      </button>
    </div>
  </div>
</template>

<script>
import { request, setToken, setUserInfo } from '../api/index';

export default {
  name: 'Login',
  data() {
    return {
      form: {
        username: '',
        password: '',
      },
      loading: false,
      errorMsg: '',
    };
  },
  methods: {
    async handleLogin() {
      if (!this.form.username.trim()) {
        this.errorMsg = '请输入用户名';
        return;
      }
      if (!this.form.password) {
        this.errorMsg = '请输入密码';
        return;
      }
      this.errorMsg = '';
      this.loading = true;
      try {
        const res = await request('/login.php', {
          method: 'POST',
          body: this.form,
        });
        setToken(res.data.token);
        setUserInfo(res.data.userInfo);
        this.$router.push('/');
      } catch (e) {
        this.errorMsg = e.message;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.login-container {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.login-card {
  width: 400px;
  padding: 40px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
}

.login-title {
  text-align: center;
  font-size: 24px;
  color: #333;
  margin-bottom: 8px;
}

.login-desc {
  text-align: center;
  font-size: 14px;
  color: #999;
  margin-bottom: 32px;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 6px;
  font-size: 14px;
  color: #555;
}

.form-group input {
  width: 100%;
  height: 40px;
  padding: 0 12px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  font-size: 14px;
  outline: none;
  transition: border-color 0.3s;
}

.form-group input:focus {
  border-color: #1677FF;
}

.error-msg {
  color: #ff4d4f;
  font-size: 13px;
  margin-bottom: 12px;
  text-align: center;
}

.login-btn {
  width: 100%;
  height: 42px;
  background: #1677FF;
  color: #fff;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  transition: background 0.3s;
}

.login-btn:hover {
  background: #4096ff;
}

.login-btn:disabled {
  background: #a0c4ff;
  cursor: not-allowed;
}

.login-tip {
  text-align: center;
  color: #ccc;
  font-size: 12px;
  margin-top: 16px;
}
</style>
